import React, {useMemo} from 'react';
import {useIntl} from 'react-intl';
import {useTable} from 'react-table';
import * as columnFormatters from '../../../../_common/column-formatters';
import {shallowEqual, useSelector} from "react-redux";
import {CommonTable} from "../../../../_common/components/CommonTable/CommonTable";
import styles from './styles.module.scss';

export function PartnersList() {
  const intl = useIntl();
  const tableRows = useSelector(
    (state) => state.partners.partnersOptions,
    shallowEqual
  );

  const columns = useMemo(() => [
    {
      accessor: 'name',
      Header: intl.formatMessage({
        id: 'partners-popup-manage-column-name',
        defaultMessage: 'Name'
      })
    },
    {
      accessor: 'phone',
      Header: intl.formatMessage({
        id: 'partners-popup-manage-column-phone',
        defaultMessage: 'Phone'
      })
    },
    {
      accessor: 'email',
      Header: intl.formatMessage({
        id: 'partners-popup-manage-column-email',
        defaultMessage: 'Email'
      })
    },
    {
      accessor: 'description',
      Header: intl.formatMessage({
        id: 'partners-popup-manage-column-description',
        defaultMessage: 'Description'
      })
    },
    {
      accessor: 'createdAt',
      Header: intl.formatMessage({
        id: 'partners-popup-manage-column-createdAt',
        defaultMessage: 'Created at'
      })
    },
    {
      accessor: 'registrationLink',
      Header: intl.formatMessage({
        id: 'partners-popup-manage-column-link',
        defaultMessage: 'Show link'
      })
    },
  ], [intl]);
  const data = useMemo(() => [
    ...tableRows.filter(Boolean).map((item) => {
      return {
        name: columnFormatters.NormalColumnFormatter(item?.name),
        phone: columnFormatters.NormalColumnFormatter(item.phone),
        email: columnFormatters.NormalColumnFormatter(item.email),
        description: columnFormatters.NormalColumnFormatter(item.description),
        createdAt: columnFormatters.DateNormalColumnFormatter(item.createdAt),
        registrationLink: columnFormatters.CopyPartnersLinkColumnFormatter(item.registrationLink),
      };
    })
  ], [tableRows]);

  return (
    <CommonTable
      tableProps={useTable({columns, data})}
      customTableStyles={styles.table}
    />
  );
}
